module.exports = __webpack_public_path__ + "static/media/02_04.af08b1a1.png";